export default "__VITE_ASSET__vYpXBoDr__"